export default __webpack_public_path__ + "static/media/Group 6428@3x.53cd8852.png";